import React from "react";
import { Helmet } from "react-helmet";

const MetaTags = ({
  title,
  type,
  siteName,
  url,
  keywords,
  description,
  revisitAfter,
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta property="ak:title" content={title} />
      <meta property="ak:type" content={type} />
      <meta property="ak:site_name" content={siteName} />
      <meta property="ak:url" content={url} />
      <meta name="keywords" content={keywords} />
      <meta
        property="ak:description"
        name="description"
        content={description}
      />
      <meta name="robots" content="all" />
      <meta name="revisit-after" content={revisitAfter} />
      <meta name="copyright" content="AK Crackers" />
      <meta name="language" content="English" />
      <meta name="distribution" content="Global" />
    </Helmet>
  );
};

export default MetaTags;
